class VideoCarouselPlayer extends HTMLElement {
    constructor() {
      super();
      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.stopEvent = this.stopEvent.bind(this);
      this.onExternalOpen = this.onExternalOpen.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
    }
  
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
  
      this.trigger = this.querySelector("[data-video-trigger]");
      this.closeBtn = this.querySelector("[data-video-close]");
      this.iframe = this.querySelector("[data-video-iframe]");
      this.embedUrl = this.dataset.embedUrl || "";
  
      if (!this.trigger || !this.closeBtn || !this.iframe || !this.embedUrl) return;
  
      this.trigger.addEventListener("click", this.onTriggerClick);
      this.closeBtn.addEventListener("click", this.onCloseClick);
      document.addEventListener("video-carousel:open", this.onExternalOpen);
      document.addEventListener("keydown", this.onKeyDown);
  
      ["pointerdown", "mousedown", "touchstart", "touchmove", "touchend"].forEach((eventName) => {
        this.trigger.addEventListener(eventName, this.stopEvent, { passive: false });
        this.closeBtn.addEventListener(eventName, this.stopEvent, { passive: false });
      });
    }
  
    disconnectedCallback() {
      if (!this.initialized) return;
  
      if (this.trigger) {
        this.trigger.removeEventListener("click", this.onTriggerClick);
        ["pointerdown", "mousedown", "touchstart", "touchmove", "touchend"].forEach((eventName) => {
          this.trigger.removeEventListener(eventName, this.stopEvent, { passive: false });
        });
      }
  
      if (this.closeBtn) {
        this.closeBtn.removeEventListener("click", this.onCloseClick);
        ["pointerdown", "mousedown", "touchstart", "touchmove", "touchend"].forEach((eventName) => {
          this.closeBtn.removeEventListener(eventName, this.stopEvent, { passive: false });
        });
      }
  
      document.removeEventListener("video-carousel:open", this.onExternalOpen);
      document.removeEventListener("keydown", this.onKeyDown);
    }
  
    stopEvent(event) {
      event.stopPropagation();
  
      if (event.type === "touchmove") {
        event.preventDefault();
      }
    }
  
    onTriggerClick(event) {
      event.preventDefault();
      event.stopPropagation();
  
      if (!this.embedUrl) return;
  
      document.dispatchEvent(
        new CustomEvent("video-carousel:open", {
          detail: { opener: this }
        })
      );
  
      this.open();
    }
  
    onCloseClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }
  
    onExternalOpen(event) {
      if (!event.detail || event.detail.opener === this) return;
      this.close();
    }
  
    onKeyDown(event) {
      if (event.key === "Escape") {
        this.close();
      }
    }
  
    open() {
      if (!this.iframe || !this.embedUrl) return;
  
      if (this.iframe.getAttribute("src") !== this.embedUrl) {
        this.iframe.setAttribute("src", "");
        requestAnimationFrame(() => {
          this.iframe.setAttribute("src", this.embedUrl);
        });
      }
  
      this.classList.add("is-playing");
  
      const swiperEl = this.closest(".video-carousel__swiper");
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.allowTouchMove = false;
      }
    }
  
    close() {
      if (this.iframe) {
        this.iframe.setAttribute("src", "");
      }
  
      this.classList.remove("is-playing");
  
      const swiperEl = this.closest(".video-carousel__swiper");
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.allowTouchMove = true;
      }
    }
  }
  
  if (!customElements.get("video-carousel-player")) {
    customElements.define("video-carousel-player", VideoCarouselPlayer);
  }